'use client';

import {
  generateOrganizationSchema,
  generateWebsiteSchema,
  generateLocalBusinessSchema,
  generateDefaultFAQSchema,
  generateGemstoneSchema,
} from '@/lib/seo';

// Gemstone data for structured schema
const gemstoneData = [
  {
    name: 'Ruby',
    nepaliName: 'माणिक',
    planet: 'Sun (Surya)',
    benefits: ['Leadership', 'Confidence', 'Fame', 'Government favor', 'Health vitality'],
  },
  {
    name: 'Pearl',
    nepaliName: 'मोती',
    planet: 'Moon (Chandra)',
    benefits: ['Mental peace', 'Emotional balance', 'Good relationships', 'Prosperity'],
  },
  {
    name: 'Red Coral',
    nepaliName: 'मूँगा',
    planet: 'Mars (Mangal)',
    benefits: ['Courage', 'Energy', 'Property gains', 'Victory over enemies', 'Marriage'],
  },
  {
    name: 'Emerald',
    nepaliName: 'पन्ना',
    planet: 'Mercury (Budh)',
    benefits: ['Intelligence', 'Communication', 'Business success', 'Education', 'Speech'],
  },
  {
    name: 'Yellow Sapphire',
    nepaliName: 'पुखराज',
    planet: 'Jupiter (Guru/Brihaspati)',
    benefits: ['Wisdom', 'Wealth', 'Marriage', 'Children', 'Spiritual growth', 'Career success'],
  },
  {
    name: 'Diamond',
    nepaliName: 'हीरा',
    planet: 'Venus (Shukra)',
    benefits: ['Luxury', 'Love', 'Beauty', 'Artistic abilities', 'Marital bliss'],
  },
  {
    name: 'Blue Sapphire',
    nepaliName: 'नीलम',
    planet: 'Saturn (Shani)',
    benefits: ['Career growth', 'Discipline', 'Wealth protection', 'Long life', 'Success'],
  },
  {
    name: 'Hessonite Garnet',
    nepaliName: 'गोमेद',
    planet: 'Rahu',
    benefits: ['Protection from evil', 'Clear thinking', 'Success in politics', 'Speculation gains'],
  },
  {
    name: "Cat's Eye",
    nepaliName: 'लहसुनिया',
    planet: 'Ketu',
    benefits: ['Spiritual progress', 'Protection', 'Intuition', 'Liberation', 'Hidden wealth'],
  },
];

/**
 * StructuredData Component
 * Renders comprehensive JSON-LD structured data for SEO
 * Optimized for: Best Astrology Nepal, Remedies, Spiritual Healing, Gemstones
 */
export default function StructuredData() {
  const organizationSchema = generateOrganizationSchema();
  const websiteSchema = generateWebsiteSchema();
  const localBusinessSchema = generateLocalBusinessSchema();
  const faqSchema = generateDefaultFAQSchema();
  const gemstoneSchema = generateGemstoneSchema(gemstoneData);

  return (
    <>
      {/* Organization Schema - Brand Identity */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      
      {/* Website Schema - Site-wide SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      
      {/* LocalBusiness/ProfessionalService Schema - Local SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      
      {/* FAQ Schema - Featured Snippets */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      
      {/* Gemstone Products Schema - Gemstone Keywords */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(gemstoneSchema) }}
      />
    </>
  );
}
